module.exports = __webpack_public_path__ + "static/media/Pago aprobado.c9d5cd20.svg";